export default function () {
    return useRuntimeConfig().public.domain
}